/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class BoardsApiConfiguration {
  rootUrl: string = 'https://boards-dev.internal.greencliff-15b39379.northeurope.azurecontainerapps.io/api';
}

/**
 * Parameters for `BoardsApiModule.forRoot()`
 */
export interface BoardsApiConfigurationParams {
  rootUrl?: string;
}
